import { render } from "./login-index.vue?vue&type=template&id=10bb73c5&scoped=true"
import script from "./login-index.vue?vue&type=script&lang=js"
export * from "./login-index.vue?vue&type=script&lang=js"

import "./login-index.vue?vue&type=style&index=0&id=10bb73c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bb73c5"]])

export default __exports__